import { useMutation, useQueryClient } from '@tanstack/react-query';

import backendService from '../services/backendService';
import { Score } from '../services/backendService/types';
import { useMetrics } from './useMetrics';

const useDismissResponse = (
  gameId?: string,
  currentRound?: string | null,
  cacheKey?: (string | undefined)[],
) => {
  const client = useQueryClient();
  const metrics = useMetrics();
  const { mutate: dismissResponse, isPending: isLoading } = useMutation({
    mutationFn: ({ responseId, dismiss }: { responseId: string; dismiss: boolean }) => {
      if (!currentRound) return Promise.resolve(undefined);
      if (!gameId) return Promise.resolve(undefined);
      metrics.logEvent('Curimote.dismiss', {
        dismiss,
        responseId,
        roundId: currentRound,
        gameId,
      });
      return backendService.instance.game.dismissQuestion({
        responseId,
        roundId: currentRound,
        gameId,
        dismiss,
      });
    },

    onMutate: ({ responseId }) => {
      if (cacheKey) {
        client.cancelQueries({ queryKey: cacheKey });

        const previousResults = client.getQueryData<Score[]>(cacheKey);

        client.setQueryData<Score[] | undefined>(cacheKey, scores => {
          if (!scores) return scores;
          return scores.filter(score => score.responseId !== responseId);
        });
        return () => client.setQueryData(cacheKey, previousResults);
      }
    }
  });
  return { dismissResponse, isDismissing: isLoading };
};
export default useDismissResponse;
